import { render, staticRenderFns } from "./Manuales.vue?vue&type=template&id=0b479185&"
import script from "./Manuales.vue?vue&type=script&lang=js&"
export * from "./Manuales.vue?vue&type=script&lang=js&"
import style0 from "./Manuales.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports